/**
 * Legacy Routes
 *
 * These routes handle backwards compatibility for old URL patterns.
 * They load the appropriate component based on request/contract type and user type.
 *
 * Routes:
 * - `/requests/:id` - Legacy route that loads the appropriate pending component based on request type and user type
 * - `/bookings/:contractId` - Legacy route that loads the appropriate contract component based on contract type, status, and user type
 * - `/provider/bookings/:contractId` - Legacy route that loads the appropriate contract component based on contract type, status, and user type
 */
import { RouteConfig } from 'vue-router';
import { requireAuthenticated, requireSeeker, requireProvider } from '@/router/guards/authGuards';

const legacyRoutes: RouteConfig[] = [
  {
    path: '/requests/:id',
    name: 'request-legacy',
    component: () => import('@/apps/requests/LegacyRequestLoader.vue'),
    props: (route) => ({ requestId: route.params.id }),
    beforeEnter: requireAuthenticated,
  },
  {
    path: '/bookings/:contractId',
    name: 'seeker-contract',
    component: () => import('@/apps/bookings/LegacyContractLoader.vue'),
    props: (route) => ({ contractId: route.params.contractId }),
    beforeEnter: requireSeeker,
  },
  {
    path: '/provider/bookings/:contractId',
    name: 'provider-contract',
    component: () => import('@/apps/bookings/LegacyContractLoader.vue'),
    props: (route) => ({ contractId: route.params.contractId }),
    beforeEnter: requireProvider,
  },
];

export default legacyRoutes;
